import { useTranslation } from 'gatsby-plugin-react-i18next';
import { FlyInText } from '../Atoms/Animations';

const Text = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 px-5- lg:px-8">
      <div className="max-w-screen-2xl w-full mx-auto flex flex-row">
        <div className="w-0 lg:w-5/12" />
        <FlyInText tag='p' className="px-4 lg:px-0 text-4xl lg:text-5xl font-cirka lg:w-1/2">
          {t('text.text')}
        </FlyInText>
        <div className="lg:w-1/12 lg:block hidden" />
      </div>
    </section>
  );
}

export default Text;
